import { config } from '@/config';
export const TipoComercioService = {
    async getTipoComercioById(id) {
        const response = await fetch(`${config.API_URL}/api/TipoComercio/${id}`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error(`Error al obtener el tipo de comercio con id ${id}`);
        }
        const data = await response.json();
        return data;
    },
    async getAllTipoComercios() {
        const response = await fetch(`${config.API_URL}/api/TipoComercio`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error('Error al obtener todos los tipos de comercio');
        }
        const result = await response.json();
        // Verifica que `datos` existe y es un array
        if (!result.datos || !Array.isArray(result.datos)) {
            console.error('Se esperaba un array de tipos de comercio en la propiedad "datos" pero se recibió:', result);
            return []; // Devuelve un array vacío en caso de error
        }
        return result.datos;
    },
};
